import { addRoutes } from '@/router'
import service from '@/http/request'

const state = {
  routes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.routes = routes
  }
}

const actions = {
  generateRoutes({ commit }) {
    return new Promise((resolve, reject) => {
      const params = {
        userId:parseInt( localStorage.getItem('userId') ||0),
        appId:parseInt( localStorage.getItem('appId')|| 0)
      }
      console.log('路由列表请求参数:', params)
      service.post(`api/Business/GetUserMenuList`,params).then(response => {
        console.log('路由列表响应:', response)
        if (response.data.code === 20000) {
          const asyncRoutes = response.data.data || []
          console.log('获取到的动态路由:', asyncRoutes)
          commit('SET_ROUTES', asyncRoutes)
          addRoutes(asyncRoutes)
          resolve(asyncRoutes)
        } else {
          const error = new Error(`获取路由失败，错误码: ${response.data.code}`)
          console.error('路由获取失败:', error)
          reject(error)
        }
      }).catch(error => {
        console.error('获取路由请求失败:', error)
        // 保留原始错误码
        if (error.response && error.response.data && error.response.data.code === 30002) {
          error.code = 30002
        }
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/permission.js